<template>
  <div>
    <app-collapse accordion class="row block pr-2 pl-2">
      <app-collapse-item
          ref="collapseOT"
          title="OT activa"
          :autoClose="false"
          :customArrowDirection="true">
        <table-render
          :rows="rowsOT"
          :schema="schema"
          :show-checkboxes="false"
          :stickyHeader="`calc(100vh - 2.5rem)`"
          id="log_tracking_ot">
            <template #delivery_carrier_status="scope">
              {{scope.rowdata.delivery_carrier_status}}
              <a :id="`tooltip-${scope.rowdata.delivery_status_id}`" v-if="!!scope.rowdata.tracking_json_data" >
                <feather-icon
                  icon="EyeIcon"
                  size="14"
                  style="color: #337ab7"
                />
              </a>
              <b-tooltip show :target="`tooltip-${scope.rowdata.delivery_status_id}`" placement="right">
                <p>Detalle del Log Tracking</p>
                {{scope.rowdata.tracking_json_data}}
              </b-tooltip>
            </template>
            <template #origin="scope">
              {{scope.rowdata.origin || 'Sin origen definido'}}
            </template>
            <template #tracking_key="scope">
              {{scope.rowdata.tracking_key || 'Sin Clave Definida'}}
            </template>
            <template #comment="scope">
              {{scope.rowdata.comment || 'Sin comentario'}}
            </template>
        </table-render>
      </app-collapse-item>
      <app-collapse-item
          ref="collapseOTHistory"
          title="Historial de OTs"
          :autoClose="false"
          :customArrowDirection="true">
        <table-render
          :rows="rowsOTHistory"
          :schema="schema"
          :show-checkboxes="false"
          :stickyHeader="`calc(100vh - 2.5rem)`"
          id="log_tracking_historic">
            <template #delivery_carrier_status="scope">
              {{scope.rowdata.delivery_carrier_status}}
              <a :id="`tooltip-${scope.rowdata.delivery_status_id}`" v-if="!!scope.rowdata.tracking_json_data" >
                <feather-icon
                  icon="EyeIcon"
                  size="14"
                  style="color: #337ab7"
                />
              </a>
              <b-tooltip show :target="`tooltip-${scope.rowdata.delivery_status_id}`" placement="right">
                <p>Detalle del Log Tracking</p>
                {{scope.rowdata.tracking_json_data}}
              </b-tooltip>
            </template>
            <template #origin="scope">
              {{scope.rowdata.origin || 'Sin origen definido'}}
            </template>
            <template #tracking_key="scope">
              {{scope.rowdata.tracking_key || 'Sin Clave Definida'}}
            </template>
            <template #comment="scope">
              {{scope.rowdata.comment || 'Sin comentario'}}
            </template>
        </table-render>
      </app-collapse-item>
    </app-collapse>
  </div>
</template>

<script>
import TableRender from '@/views/components/custom/table-render/TableRender.vue'
import { mapGetters } from 'vuex'
export default {
  components: { TableRender },
  name: 'log-tracking',
  data() {
    return {
      schema: [],
      rowsOT: [],
      rowsOTHistory: []
    }
  },
  computed: {
    ...mapGetters({
      delivery: 'getDeliveryDetails'
    })
  },
  watch: {
    delivery() {
      this.logs = {
        carrier_code: this.delivery.delivery.carrier.code,
        delivery_tracking_number: this.delivery.delivery.tracking_number,
        delivery_carrier_trackings: this.delivery.delivery_carrier_trackings
      }
      this.setInitialData()
    }
  },
  updated() {
    if (!!(Array.isArray(this.rowsOT) && this.rowsOT.length !== 0)) this.$refs.collapseOT.openCollapseManually()
    if (!!(Array.isArray(this.rowsOTHistory) && this.rowsOTHistory.length !== 0)) this.$refs.collapseOTHistory.openCollapseManually()
  },
  mounted() {
    if (this.delivery?.delivery) {
      this.logs = {
        carrier_code: this.delivery.delivery.carrier.code,
        delivery_tracking_number: this.delivery.delivery.tracking_number,
        delivery_carrier_trackings: this.delivery.delivery_carrier_trackings
      }
      this.setInitialData()
    }
  },
  methods: {
    setInitialData () {
      this.schema = [
        {label: 'Estado Courier', sortable: true, key: 'delivery_carrier_status', useSlot: true},
        {label: 'Origen', sortable: true, key: 'origin', useSlot: true},
        {label: 'OT del Registro', sortable: true, key: 'tracking_key', useSlot: true},
        {label: 'Fecha de Estado', sortable: true, key: 'tracking_date'},
        {label: 'Fecha de Tracking', sortable: true, key: 'created_at'},
        {label: 'Estado Envíame', sortable: true, key: 'delivery_status_name'},
        {label: 'Comentario', sortable: true, key: 'comment', useSlot: true}
      ]
      if (this.logs.delivery_carrier_trackings) {
        this.rowsOT = []
        this.rowsOTHistory = []
        this.logs.delivery_carrier_trackings.map((track) => {
          const tracking = {
            ...track,
            tracking_date: this.$options.filters.moment(track.tracking_date, 'YYYY-MM-DD HH:mm:ss'),
            created_at: this.$options.filters.moment(track.created_at.date, 'YYYY-MM-DD HH:mm:ss')
          }
          if (track.tracking_key) tracking.tracking_key = `${track.tracking_key} [${track.carrier_code}]`
          if ((this.logs?.delivery_tracking_number === track?.tracking_key) && (this.logs?.carrier_code === track.carrier_code)) {
            this.rowsOT.push(tracking)
          } else {
            this.rowsOTHistory.push(tracking)
          }
        })
      }
    }
  }
}
</script>